import React from 'react'
import ListTransaction from './ListTransaction'
import useAuth from '../../hooks/useAuth'

export default function TransactionManagement() {
    const { user } = useAuth();
    return (
        <div>
            {user && <ListTransaction />}
        </div>
    )
}
